import { Paper, Typography } from "@material-ui/core";
import { Edit, Delete } from "@material-ui/icons";
import {
  StandardRowContainer,
  StretchRow,
} from "components/Layout/StandardStyledComponents";
import { useStyles } from "Theme/styles";
import { StepInput } from "./StepsCreator";

interface StepCardProps {
  step: StepInput;
}

export default function StepCard({ step }: StepCardProps) {
  const classes = useStyles();
  return (
    <Paper className={classes.paperCard}>
      <StandardRowContainer>
        <StretchRow>
          <Typography>{step.name}</Typography>
        </StretchRow>
        <Edit />
        <Delete />
      </StandardRowContainer>
    </Paper>
  );
}
